<template>
  <div class="order_home">
    <div class="white_box">
      <div class="box_title">

        <div class="box_title">
          申请换机
        </div>
        <div class="title_line"></div>
      </div>
      <!-- <div class="flex jcsb mar_t_35">
        <div>名称</div>
        <input type="text" placeholder="请输入名称" v-model="SerachValue">
      </div> -->
      <div>
        <van-field v-model="formData.name" label="名称" placeholder="请输入名称" input-align="right" class="custom-field" />
      </div>
      <div>
        <van-field v-model="formData.phone" label="手机号" readonly placeholder="请输入手机号" input-align="right"
          class="custom-field" />
      </div>
      <div>
        <van-field v-model="formData.id_card" label="身份证号" placeholder="请输入身份证号" input-align="right"
          class="custom-field" />
      </div>
      <div>
        <van-field v-model="formData.imei" label="IMEI" readonly placeholder="请输入IMEI" input-align="right"
          class="custom-field" />
      </div>
      <div class="flex ai_center jcsb" @click="bottomPopClick('brand_id')">
        <div>
          <van-field readonly v-model="formData.brand" label="手机品牌" input-align="right" placeholder="请选择手机品牌"
            class="custom-field" style="width: 108%;" />
        </div>
        <img class="arow" src="@/assets/images/unicom/arow.png" alt="">
      </div>

      <div class="flex ai_center jcsb">
        <div @click="bottomPopClick('model_id')">
          <van-field readonly v-model="formData.model_name" label="手机型号" input-align="right" placeholder="请选择手机型号"
            class="custom-field" style="width: 108%;" />
        </div>
        <img class="arow" src="@/assets/images/unicom/arow.png" alt="">

      </div>
      <div class="flex ai_center jcsb">
        <div @click="bottomPopClick('ram_size')">
          <van-field readonly v-model="formData.ram_size" label="手机规格" input-align="right" placeholder="请选择手机规格"
            class="custom-field" style="width: 108%;" />
        </div>
        <img class="arow" src="@/assets/images/unicom/arow.png" alt="">
      </div>

      <div>
        <van-field readonly v-model="formData.insure_san" label="产品名称" placeholder="请输入产品名称" input-align="right"
          class="custom-field" />
      </div>
      <div class="van-field-simulate">
        <div class="van-field-simulate-label">保值金额</div>
        <div class="van-field-simulate-value">￥{{ formData.claims_money || 0 }}</div>
      </div>
      <!-- <div class="flex ai_center jcsb">
        <div @click="damageClick()">
          <van-field readonly v-model="formData.damage_title" label="手机故障" input-align="right" placeholder="请选择手机故障项"
            class="custom-field " style="width: 108%;" />
        </div>
        <img class="arow" src="@/assets/images/unicom/arow.png" alt="">
      </div> -->


    </div>
    <div class="white_box mar_t_35">
      <div class="box_title">

        <div class="box_title">
          申请照片
        </div>
        <div class="title_line"></div>
      </div>
      <div class="flex m_t_40">
        <UnicomPicUploader :example="'https://img.fanxinghuishou.cn/20260325/184215617.jpg'"
          @change="(url) => (formData.tem_img = url)" :src="formData.tem_img" :title="'1.手机正面照'">
        </UnicomPicUploader>
        <UnicomPicUploader :example="'https://img.fanxinghuishou.cn/20260319/267141223.jpg'"
          @change="(url) => (formData.tem_card = url)" :src="formData.tem_card" :title="'2.身份证正面照'"
          style="padding-left: 15px">
        </UnicomPicUploader>
      </div>
      <div class="flex m_t_40">
        <UnicomPicUploader :example="'https://img.fanxinghuishou.cn/20260323/811033754.jpg'"
          @change="(url) => (formData.additional1 = url)" :src="formData.additional1" :title="'3.摄像头（前）'">
        </UnicomPicUploader>
        <UnicomPicUploader :example="'https://img.fanxinghuishou.cn/20260323/811033754.jpg'"
          @change="(url) => (formData.additional2 = url)" :src="formData.additional2" :title="'4.摄像头（后）'"
          style="padding-left: 15px">
        </UnicomPicUploader>
      </div>
      <div class="flex m_t_40">
        <UnicomPicUploader :example="'https://img.fanxinghuishou.cn/20260323/637250133.jpg'"
          @change="(url) => (formData.additional3 = url)" :src="formData.additional3" :title="'5.边框1'">
        </UnicomPicUploader>
        <UnicomPicUploader :example="'https://img.fanxinghuishou.cn/20260323/053518617.jpg'"
          @change="(url) => (formData.additional4 = url)" :src="formData.additional4" :title="'6.边框2'"
          style="padding-left: 15px">
        </UnicomPicUploader>
      </div>
      <div class="flex m_t_40">
        <UnicomPicUploader :example="'https://img.fanxinghuishou.cn/20260323/858448312.jpg'"
          @change="(url) => (formData.additional5 = url)" :src="formData.additional5" :title="'7.边框3'">
        </UnicomPicUploader>
        <UnicomPicUploader :example="'https://img.fanxinghuishou.cn/20260323/648444165.jpg'"
          @change="(url) => (formData.additional6 = url)" :src="formData.additional6" :title="'8.边框4'"
          style="padding-left: 15px">
        </UnicomPicUploader>
      </div>
      <UnicomPicUploader :example="'https://img.fanxinghuishou.cn/20260325/024458751.jpg'"
        @change="(url) => (formData.tem_back = url)" :src="formData.tem_back" :title="'9.手机后盖'">
      </UnicomPicUploader>
    </div>
    <div class="m_t_40">
      <div class="btn btn-top ">
        <van-button color="#577BB5" size="large" @click='submit()'>确认提交</van-button>
      </div>
    </div>
    <van-popup v-model="phoneTypeBottom" position="bottom" closeable round>
      <div class="flex flex_center phone_title">{{ phoneTypeTitle }}</div>
      <div class="phone_type_box">
        <div @click="phoneTypeClick(item.id, item.name, ind)" v-for="(item, ind) in bottomTypeList" :key="ind"
          :class="item.isClick ? 'flex flex_center phone_type_item click_phone_item' : 'flex flex_center phone_type_item'">
          <div>{{ item.name }}</div>
        </div>
      </div>

    </van-popup>
    <van-popup v-model="damageBottom" position="bottom" closeable round>
      <div class="flex flex_center phone_title">手机故障(可多选)</div>
      <div class="flex_wrap">
        <div v-for="(item, ind) in damageConfigList" :key="ind" @click="item.isClick = !item.isClick"
          :class="item.isClick ? 'damage_item damage_click' : 'damage_item'"> {{ item.damage_title }}
          <!-- 只有选中才显示，并且定位右下角 -->
          <div v-if="item.isClick" class="damage-icon">
            <van-icon name="success" />
          </div>
        </div>

      </div>
      <div class="damage_btn">
        <van-button color="#577BB5" size="large" @click='damageSubmit()'>确认提交</van-button>
        <div class="flex flex_center damage_cancel" @click='damageBottom = false'>取消</div>
      </div>

    </van-popup>
  </div>
</template>

<script>
import {
  damageConfig2, getPhoneBrand, getPhoneModel,
  getPhoneRam, changePrice, setOrderClaims
} from "@/api/unicom";

export default {
  name: "orderhome",
  data() {
    return {
      formData: {
      },
      bottomType: 'brand_id',
      bottomTypeList: [],
      brandList: [],
      modelList: [],
      ramList: [],
      phoneTypeBottom: false,
      phoneTypeTitle: '',
      damageBottom: false,
      damageConfigList: []
    }
  },

  mounted() {
    const queryData = JSON.parse(this.$route.query.data) || {}
    this.formData = queryData
    this.order_id =
      damageConfig2()
        .then((res) => {
          console.log(res);
          this.damageConfigList = res.data ? res.data.map((le) => {
            return {
              ...le,
              isClick: false
            }
          }) : []
        })
        .catch((err) => {
          this.$toast((err && err.msg) || "获取数据失败");
        });
    getPhoneBrand().then((res) => {
      const { brandList } = res.data
      this.brandList = brandList ? brandList.map((le) => {
        return {
          name: le.brand,
          id: le.brand_id,
          isClick: false
        }
      }) : []
      this.phoneTypeTitle = '选择手机品牌'
      this.bottomTypeList = this.brandList
    })
      .catch((err) => {
        this.$toast((err && err.msg) || "获取数据失败");
      });
  },
  methods: {
    bottomPopClick(type) {
      this.bottomType = type
      if (type == 'brand_id') {
        this.phoneTypeTitle = '选择手机品牌'
        this.bottomTypeList = this.brandList
      } else if (type == 'model_id') {
        if (this.modelList.length == 0) {
          this.$toast(("请先选择手机品牌"));
          return
        }
        this.phoneTypeTitle = '选择手机型号'
        this.bottomTypeList = this.modelList
      } else if (type == 'ram_size') {
        if (this.modelList.length == 0 || this.ramList.length == 0) {
          this.$toast(("请先选择手机型号"));
          return
        }
        this.phoneTypeTitle = '选择手机规格'
        this.bottomTypeList = this.ramList
      }
      this.phoneTypeBottom = true
    },

    phoneTypeClick(id, name, index) {
      if (this.bottomType == 'brand_id') {
        if(this.formData.brand_id && this.formData.brand_id === id){
          this.phoneTypeBottom = false
          return
        }
        this.formData.brand_id = id
        this.formData.brand = name
        this.formData.model_id = ""
        this.formData.model_name = ""
        this.formData.ram_size = ""
        this.modelList = []
        this.ramList = []
        const { order_id } = this.formData
        changePrice({ brand_id: id, order_id })
          .then((res) => {
            console.log('changePrice', res);

            this.formData.claims_money = res.data.claims_money || 0
            this.formData.ins_service_name = res.data.ins_service_name
          })
          .catch((err) => {
            this.$toast((err && err.msg) || "获取数据失败");
          });
        getPhoneModel({ brand_id: id })
          .then((res) => {
            this.modelList = res.data ? res.data.map((le) => {
              return {
                name: le.model_name,
                id: le.model_id,
                isClick: false
              }
            }) : []
            this.phoneTypeBottom = false
          })
          .catch((err) => {
            this.$toast((err && err.msg) || "获取数据失败");
          });
      } else if (this.bottomType == 'model_id') {
        if(this.formData.model_id && this.formData.model_id === id){
          this.phoneTypeBottom = false
          return
        }
        this.formData.model_id = id
        this.formData.model_name = name
        this.formData.ram_size = ""
        this.ramList = []
        getPhoneRam({ model_id: id })
          .then((res) => {
            this.ramList = res.data ? res.data.map((le) => {
              return {
                name: le.ram_size,
                id: le.ram_size,
                isClick: false
              }
            }) : []
            this.phoneTypeBottom = false
          })
          .catch((err) => {
            this.$toast((err && err.msg) || "获取数据失败");
          });
      } else if (this.bottomType == 'ram_size') {
        this.formData.ram_size = id
        this.phoneTypeBottom = false
      }

    },

    damageClick() {
      this.damageBottom = true
    },
    damageSubmit() {
      const selectedList = this.damageConfigList.filter(item => item.isClick)
      const damageTitleList = selectedList.map(item => item.damage_title)
      this.formData.damage_title = damageTitleList.join(',')
      this.damageBottom = false
    },
    submit() {
      setOrderClaims(this.formData)
        .then((res) => {
          this.$emit('request')
          this.$toast((res && res.msg) || "提交成功");
        })
        .catch((err) => {
          this.$toast((err && err.msg) || "提交失败");
        });
    }
  },
}
</script>

<style lang="less" scoped>
/* 强制永久去掉 van-field 下划线，任何情况都不显示 */
/deep/ .custom-field .van-field__control {
  border-bottom: none !important;
}

/* 如果你要改整个 van-field 的高度 */
/deep/ .custom-field {
  height: 90px !important;
  border-bottom: none !important;

}



/* 模拟 vant 只读 van-field 样式 */
.van-field-simulate {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  font-size: 29px;
  line-height: 1.5;
  margin-top: 30px;
}

/* 左边 label */
.van-field-simulate-label {
  color: #323233;
  margin-right: 12px;
  margin-left: 25px;
}

/* 右边 value（只读样式） */
.van-field-simulate-value {
  flex: 1;
  text-align: right;
  color: #FF4133;
}

.flex {
  display: flex;
}

.flex_center {
  justify-content: center;
  align-items: center;
}

.jcsb {
  justify-content: space-between;
}

.ai_center {
  align-items: center;
}

.hei_90 {
  height: 90px;
}

.ai_end {
  align-items: flex-end;
}

.mar_t_35 {
  margin-top: 35px;
}

.m_t_40 {
  margin-top: 40px;
}

.phone_title {
  height: 115px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 32px;
  color: #333333;
  line-height: 44px;
  text-align: center;
  font-style: normal;
}

.phone_type_box {
  height: 600px;
  overflow-y: scroll;
}

.phone_type_item {
  height: 88px;
  border-radius: 16px;
  padding: 25px 0;
  margin: 20px 30px;
}

.click_phone_item {
  background: rgba(87, 123, 181, 0.12);
  color: #577BB5;
}

.flex_wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-left: 25px;
}

.damage_item {
  width: 220px;
  height: 72px;
  background: #F7F8FA;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 26px;
  margin: 20px 0;

  /* 必须加这个，让图标定位相对它 */
  position: relative;
}

.damage_click {
  background: rgba(87, 123, 181, 0.12);
  color: #577BB5;
  font-weight: 600;

}

/* ✔ 图标定位到右下角 */
.damage-icon {
  position: absolute;
  bottom: 1px;
  /* 距离底部 */
  right: 1px;
  /* 距离右侧 */
  font-size: 20px;
  color: #fff;
  width: 30px;
  height: 20px;
  background: #577BB5;
  border-radius: 12px 0px 8px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.damage_btn {
  margin: 80px 20px;
}

.damage_cancel {
  margin-top: 20px;
}

.btn {
  width: calc(100vw - 120px);
  margin: auto;
  margin-bottom: 35px;

  button {
    height: 88px;
  }
}

.btn-top {
  button {
    box-shadow: 0px 6px 15px 1px rgba(87, 123, 181, 0.4);
  }
}

.btn-bottom {
  button {
    box-shadow: 0px 6px 15px 1px rgba(87, 123, 181, 0.1);
    color: #577BB5 !important;
  }
}

.order_home {
  padding: 30px 25px 0 25px;
  background-color: #F7F8FA;
  // min-height: 2000px;

  .white_box {
    background: #FFFFFF;
    border-radius: 16px;
    padding: 30px 25px;

    .box_title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 32px;
      color: #333333;
      line-height: 44px;
      text-align: left;
      font-style: normal;

      .title_line {
        width: 131px;
        height: 8px;
        background: #577BB5;
        opacity: 0.4;
        margin-top: -11px;
      }
    }

    .arow {
      height: 16px;
      width: 16px;
      margin-top: 50px;
    }
  }
}
</style>
